import { DataProxy } from 'apollo-cache';
import { PagesQuery } from '../../generated/graphql';
import { PhotoTimelineItemsFragment } from './../../generated/graphql';
import { pagesQuery } from '../../components/LeftContainer/graphql';
import { produce } from 'immer';

interface Args {
  pageId: number;
  cache: DataProxy;
  photoTimelineId: number;
  photoId: number;
}

function deleteTimelinePhoto({ cache, pageId, photoTimelineId, photoId }: Args) {
  const { pages } = cache.readQuery<PagesQuery>({ query: pagesQuery })!;

  const updatedPages = produce(pages, draft => {
    const page = draft.find(p => p.id === pageId);

    if (page) {
      page.items = page.items || [];
      const timeline = page.items.find(i => i.id === photoTimelineId) as PhotoTimelineItemsFragment;
      if (timeline) {
        timeline.photoItems = timeline.photoItems.filter(photo => 'id' in photo && photo?.id !== photoId);
      }
    }
  });

  cache.writeQuery({
    query: pagesQuery,
    data: { pages: updatedPages },
  });
}

export default deleteTimelinePhoto;
